<h2 mat-dialog-title>Modifica dettagli Mittente</h2>
<hr>
<form [formGroup]="editForm" (ngSubmit)="onSubmit()">
    <mat-dialog-content id="edit-container">
        <div class="field-container">
            <mat-form-field appearance="fill">
                <mat-label>Nome*</mat-label>
                <input matInput type="text" formControlName="name">
            </mat-form-field>
        </div>
        <div class="field-container">
            <mat-form-field appearance="fill">
                <mat-label>Descrizione*</mat-label>
                <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="4"
                    cdkAutosizeMaxRows="4" formControlName="descr"></textarea>
            </mat-form-field>
        </div>
        <div class="field-container">
            <mat-form-field appearance="fill">
                <mat-label>Descrizione opzionale</mat-label>
                <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="4"
                    cdkAutosizeMaxRows="4" formControlName="descrOpt"></textarea>
            </mat-form-field>
        </div>
        <div class="field-container">
            <mat-form-field appearance="fill">
                <mat-label>Email*</mat-label>
                <input matInput type="text" formControlName="email">
            </mat-form-field>
        </div>
        <div class="field-container">
            <mat-form-field appearance="fill">
                <mat-label>Firma*</mat-label>
                <input matInput type="text" formControlName="firma">
            </mat-form-field>
        </div>
        <div class="field-container">
            <mat-form-field appearance="fill" class="date-field">
                <mat-label>Inizio validità contratto*</mat-label>
                <input matInput [matDatepicker]="picker1" formControlName="contractStartDate">
                <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                <mat-datepicker #picker1 disabled="false"></mat-datepicker>
            </mat-form-field>
            <mat-form-field appearance="fill" class="date-field">
                <mat-label>Scadenza contratto*</mat-label>
                <input matInput [matDatepicker]="picker2" formControlName="contractEndDate">
                <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                <mat-datepicker #picker2 disabled="false"></mat-datepicker>
            </mat-form-field>
        </div>
    </mat-dialog-content>
    <hr>
    <mat-dialog-actions id="action-div">
        <button mat-stroked-button (click)="closeCancelling()" type="button">Annulla</button>
        <button mat-stroked-button color="primary" type="submit" [disabled]="!editForm.valid">Modifica</button>
    </mat-dialog-actions>
</form>